import { render, staticRenderFns } from "./SelectFamily.vue?vue&type=template&id=3f4f65de&scoped=true"
import script from "./SelectFamily.vue?vue&type=script&lang=js"
export * from "./SelectFamily.vue?vue&type=script&lang=js"
import style0 from "./SelectFamily.vue?vue&type=style&index=0&id=3f4f65de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4f65de",
  null
  
)

export default component.exports